export default `
  query listProjectMembershipsForCurrentUser {
    listProjectMembershipsForCurrentUser {
      id
      userId
      lastLogin
      createdAt
      workflowOrder
      starredWorkflowOrder
      project {
        id
        name
        createdAt
        workflows {
          items {
            id
          }
          nextToken
        }
        organisationId
        organisation {
          id
          name
          userId
          createdAt
          user {
            id
            firstname
            lastname
          }
        }
        jiraForgeData {
          projectId
        }
      }
    }
  }
`
